import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Security defaults helper for "strict mode".
 *
 * Goal:
 * - Reduce boilerplate in common same-origin usage.
 * - Provide safer defaults when user does NOT configure origin constraints explicitly.
 *
 * Behavior (when strict === true):
 * - Client-like options:
 *   - If targetOrigin is not provided, default to window.location.origin (same-origin only).
 *   - If neither allowedOrigins nor validateOrigin is provided, default allowedOrigins to [window.location.origin].
 * - Server-like options:
 *   - If neither allowedOrigins nor validateOrigin is provided, default allowedOrigins to [window.location.origin].
 *
 * Notes:
 * - This intentionally makes cross-origin setups fail fast unless user explicitly configures
 *   targetOrigin and allowedOrigins/validateOrigin.
 */

export function getCurrentWindowOrigin() {
  try {
    var _window$location;
    if (typeof window === 'undefined') return undefined;
    var origin = (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin;
    if (typeof origin === 'string' && origin) return origin;
  } catch (_unused) {
    /** ignore */
  }
  return undefined;
}
export function applyStrictClientSecurityDefaults(defaultTargetOrigin, options) {
  var _options$targetOrigin;
  var strict = (options === null || options === void 0 ? void 0 : options.strict) === true;
  var targetOrigin = (_options$targetOrigin = options === null || options === void 0 ? void 0 : options.targetOrigin) !== null && _options$targetOrigin !== void 0 ? _options$targetOrigin : defaultTargetOrigin;
  var allowedOrigins = options === null || options === void 0 ? void 0 : options.allowedOrigins;
  if (strict) {
    var currentOrigin = getCurrentWindowOrigin();
    if (currentOrigin) {
      if (!(options !== null && options !== void 0 && options.targetOrigin)) {
        targetOrigin = currentOrigin;
      }
      if (!(options !== null && options !== void 0 && options.allowedOrigins) && !(options !== null && options !== void 0 && options.validateOrigin)) {
        allowedOrigins = [currentOrigin];
      }
    }
  }
  if (!options) {
    return {
      targetOrigin,
      options: options
    };
  }
  if (targetOrigin === options.targetOrigin && allowedOrigins === options.allowedOrigins) {
    return {
      targetOrigin,
      options
    };
  }
  return {
    targetOrigin,
    options: _objectSpread(_objectSpread(_objectSpread({}, options), targetOrigin !== options.targetOrigin ? {
      targetOrigin
    } : null), allowedOrigins !== options.allowedOrigins ? {
      allowedOrigins
    } : null)
  };
}
export function applyStrictServerSecurityDefaults(options) {
  var strict = (options === null || options === void 0 ? void 0 : options.strict) === true;
  if (!strict) return options;
  if (options !== null && options !== void 0 && options.allowedOrigins || options !== null && options !== void 0 && options.validateOrigin) {
    return options;
  }
  var currentOrigin = getCurrentWindowOrigin();
  if (!currentOrigin) return options;
  return _objectSpread(_objectSpread({}, options), {}, {
    allowedOrigins: [currentOrigin]
  });
}